import React from 'react';
import { motion } from 'framer-motion';
const partners = [{
  name: 'Daikin D1+ Premium Partner',
  src: 'https://cdn.magicpatterns.com/uploads/2vVokvhsbE3igxg2bfPash/d1.png'
}, {
  name: 'Mitsubishi Electric Accredited Installer',
  src: 'https://cdn.magicpatterns.com/uploads/u4wNLmkihgfoVY6zFXiVRD/acc-mitsubishi.png'
}, {
  name: 'Fujitsu Infinity Partner',
  src: 'https://cdn.magicpatterns.com/uploads/2bur7AKX4bav4Ji73hJpM7/acc-fujitsu.png'
}, {
  name: 'Constructionline Gold',
  src: 'https://cdn.magicpatterns.com/uploads/2FA87CtJq3CRcUi4Xcmf5w/acc-chas.png' // Using CHAS as a distinct placeholder for Constructionline Gold
}, {
  name: 'ISO 9001',
  src: 'https://cdn.magicpatterns.com/uploads/eXZzz3xSbHUJ1wTfq3KUK3/acc-iso.png'
}, {
  name: 'Safe Contractor',
  src: 'https://cdn.magicpatterns.com/uploads/jFm1QpjEmC16VTGoXegaaN/acc-safe.png'
}, {
  name: 'CHAS',
  src: 'https://cdn.magicpatterns.com/uploads/2FA87CtJq3CRcUi4Xcmf5w/acc-chas.png'
}, {
  name: 'BESA Accreditation',
  src: 'https://cdn.magicpatterns.com/uploads/jo6rVf4k1TsuFxc8CF9hSk/acc-besa.png'
}, {
  name: 'Refcom',
  src: 'https://cdn.magicpatterns.com/uploads/jo6rVf4k1TsuFxc8CF9hSk/acc-besa.png'
}, {
  name: 'F-Gas Register',
  src: 'https://cdn.magicpatterns.com/uploads/jo6rVf4k1TsuFxc8CF9hSk/acc-besa.png'
}];
// Duplicate the array to create seamless loop
const duplicatedPartners = [...partners, ...partners];
export function PartnerLogos() {
  return <div id="partner-logos" className="w-full border-b border-gray-100 py-10 overflow-hidden bg-[#E8F0F8]" data-id="element-426">
      <motion.div className="flex items-center gap-16 md:gap-24 w-max" animate={{
      x: ['0%', '-50%']
    }} transition={{
      x: {
        duration: 60,
        repeat: Infinity,
        ease: 'linear'
      }
    }} data-id="element-427">
        {duplicatedPartners.map((partner, index) => <div key={index} className="flex flex-col items-center gap-2 flex-shrink-0" data-id="element-428">
            <img src={partner.src} alt={partner.name} className="h-12 md:h-[4.2rem] w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-429" />
            <span className="text-[10px] uppercase tracking-tighter text-primary-dark/40 font-bold text-center max-w-[120px] leading-tight" data-id="element-430">
              {partner.name}
            </span>
          </div>)}
      </motion.div>
    </div>;
}